namespace GeniuzPOS.InitialData {
    export interface PsShopTypeForm {
        ShopTypeId: Serenity.StringEditor;
        ShopTypeName: Serenity.StringEditor;
    }

    export class PsShopTypeForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsShopType';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsShopTypeForm.init)  {
                PsShopTypeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(PsShopTypeForm, [
                    'ShopTypeId', w0,
                    'ShopTypeName', w0
                ]);
            }
        }
    }
}
